<script>
    import { currency_formatter } from '../globals';
    import { onDestroy, onMount } from 'svelte';
    import Responsivetable from '../utils/responsivetable3.svelte';
    import Header from './header.svelte';
    import Flatpickr from "../utils/Flatpickr.svelte";
    import { api_host, price_setting_store, all_jobs_store, all_jobs_number_store, all_users_store, total_earned_store, user_store, company_details_store } from '../stores.js';
    import { init_data } from '../init.js';
    import { toast_message } from '../utils/toast_message';
    import { getToken, doFetch } from '../utils/Fetching.js';
    import { getFormatDateByOffset, formatDate, handle_not_subscribed, get_job_status, sort_functions, formatter } from '../utils/format.js';
    import { push } from 'svelte-spa-router';
    import Swal from "sweetalert2";


    const { auth_type, auth_token, domain_code } = getToken();

    let google;
	let map;
	let markers = [];
    let infowindows = [];
	let marker_visible_ids = [];
	let center = { lat: 0, lng: 0 };
    let company_details = {};
    let company_location = null;
    let directionsService;
    let directionsRenderer;

    let is_busy = false;
    let today = getFormatDateByOffset(0);
    let client_margin = '', contractor_margin = '', referral_duration = '', referral_discount = '';
    let price_setting = {};
    let all_jobs = [];
    let jobs = [];
    let all_jobs_number = 0;
    let all_users = [];
    let all_users_number = 0;
    let total_earned = 0;
    let myself = {};
    let statistic_data = {};
    
    let formattedValue, flatpickr;
    let date_value;
    let from_date, to_date;
    let date_range_options = {
		enableTime: false,
        dateFormat: "m/d/Y",
        mode: "range",
		onChange(selectedDates, dd, fp) {
            from_date = selectedDates[0] ? formatDate(selectedDates[0]) : false;
            to_date = selectedDates[1] ? formatDate(selectedDates[1]) : false;
            if (from_date) {
                update_numbers();
            }
		},
		onOpen() {
			console.log('opened');
		},
        plugins: [
            ShortcutButtonsPlugin({
                button: [
                    {
                        label: "Clear"
                    },
                    {
                        label: "Yesterday"
                    },
                    {
                        label: "Today"
                    },
                    {
                        label: "Tomorrow"
                    }
                ],
                label: "",
                onClick: (index, fp) => {
                    let date;
                    switch (index) {
                        case 0:
                            from_date = null;
                            to_date = null;
                            update_numbers();
                            fp.clear();
                            fp.close();
                            break;
                        case 1:
                            date = new Date(Date.now() - 24 * 60 * 60 * 1000);
                            from_date = formatDate(date);
                            to_date = formatDate(date);
                            update_numbers();
                            fp.close();
                            break;
                        case 2:
                            date = new Date();
                            from_date = formatDate(date);
                            to_date = formatDate(date);
                            update_numbers();
                            fp.close();
                            break;
                        case 3:
                            date = new Date(Date.now() + 24 * 60 * 60 * 1000);
                            from_date = formatDate(date);
                            to_date = formatDate(date);
                            update_numbers();
                            fp.close();
                            break;
                    }
                    fp.setDate(date);
                }
            })
        ]
	};

    const update_numbers = () => {
        let filtered_jobs = all_jobs;
        if (from_date && to_date) {
            filtered_jobs = all_jobs.filter(job => new Date(formatDate(job.service_date)) >= new Date(from_date) && new Date(formatDate(job.service_date)) <= new Date(to_date));
        }
        all_jobs_number = filtered_jobs.length;
        total_earned = 0;
        filtered_jobs.forEach(job => total_earned += job.total_service_price);

        let filtered_users = all_users;
        if (from_date && to_date) {
            filtered_users = all_users.filter(user => new Date(formatDate(user.created_at)) >= new Date(from_date) && new Date(formatDate(user.created_at)) <= new Date(to_date));
        }
        all_users_number = filtered_users.length;
    }

    all_jobs_number_store.subscribe(value => {
        console.log('numbers', value);
        all_jobs_number = value.all_jobs_number;
        total_earned = value.total_earned;
        all_users_number = value.all_users_number;
    });
    
    price_setting_store.subscribe(_price_setting => {
        price_setting = _price_setting;
        client_margin = _price_setting.client_margin;
        contractor_margin = _price_setting.contractor_margin;
        referral_duration = _price_setting.referral_duration;
        referral_discount = _price_setting.referral_discount;
    });

    let table_header_config = [
        {'t': 'Day', 'fm': 'dt', 'a': true},
        {'t': 'When', 'fm': 'tp', 'a': true},
        {'t': 'Client', 'fm': 'cn', 'a': true},
        {'t': 'Price', 'fm': 'p', 'a': true},
        {'t': 'Map', 'fm': 'map', 'a': true }
    ];

    let show_items = [
        {
            "id": "show",
            "i": "fas fa-eye",
            "s": "color: #1c54b2;",
            "f": (id) => {push("#/Job_Review?jid=" + id); },
            "l": "#/Job_Review?jid=<action_id>"
        },
    ];

    let field_formats = {
        "p": (p) => {
            if (typeof(p) === "string" && !p.startsWith("$")) {
                var formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD',});
                return formatter.format(parseFloat(p));
            } else {
                return p;
            }
        },
    };

    let field_styles = {
    }

    all_jobs_store.subscribe(value => {
        all_jobs = value;
        jobs = all_jobs.filter(job => formatDate(job.service_date) == formatDate(today));

        jobs = jobs.map(job => ({
            "crews": job.crews,
            "id": job.id,
            'name': job.client.first_name + ' ' + job.client.last_name,
            "cn": `<a sortValue='${job.client.first_name + " " + job.client.last_name}' href='/#/User_Review?uid=${job.uid}'>${job.client.first_name + " " + job.client.last_name}</a>`,
            "e": job.email,
            "hp": job.home_phone,
            "cp": job.mobile_phone,
            "c": job.city,
            "dt": formatDate(job.service_date),
            "tp": job.time_preference,
            "lt": job.lawn,
            "st": job.service_type,
            "sf": job.service_frequency,
            "p": `${job.total_service_price.toFixed(2)}`,
            "total_service_price": job.total_service_price,
            "ud": `${job.total_contractor_price.toFixed(2)}`,
            "total_contractor_price": job.total_contractor_price,
            "pt": job.paymethod,
            "s": get_job_status(job.status),
            "status": job.status,
            "co": formatDate(job.created_at),
            "date_filter": myself.plan_type === 'basic' ? formatDate(job.created_at) : formatDate(job.service_date),
            "ac": job.additional_comments,
            "ic": job.internal_comments,
            "lat": job.lat,
            "lng": job.lng,
            "map": `<input type="checkbox" class="map-checkbox" id="${job.id}" name="${job.id}" value="${job.id}" lat="${job.lat}" lng="${job.lng}" onchange="select_map(event)" />`,
        }));

        jobs.sort((a, b) => {
            if (a.cn.toLowerCase() < b.cn.toLowerCase()) return -1;
            if (a.cn.toLowerCase() > b.cn.toLowerCase()) return 1;
            return 0;
        });
        console.log('jobs', jobs);

        let lats = 0, lngs = 0, total_prices = 0;
        jobs.map(_j => {
            lats += _j.lat;
            lngs += _j.lng;
            total_prices += _j.total_service_price
        });
        center.lat = lats / jobs.length;
		center.lng = lngs / jobs.length;

        statistic_data = {
            'id': 'statistic', 'dt': '', 'tp': '', 'cn': '', 'p': formatter.format(total_prices), 
            'map': `<a href='/' onclick="clear_map(event)">Clear Map</a>`
        };

    });
    all_users_store.subscribe(value => {
        all_users = value;
    });
    
    user_store.subscribe(value => {
        myself = value;
    });

    company_details_store.subscribe(value => {
        console.log('company_details', value);
        company_details = value;        
    });

    onMount(async () => {
        await init_data('all');

        google = window.google;
		map = document.getElementById("map-canvas");
    });
    onDestroy(() => {
    });

    const visible_markers = (filtered) => {
        // close all info windows
        infowindows.forEach(_w => _w.close());

        for (let i = 0; i < marker_visible_ids.length; i++) {
            const jid = marker_visible_ids[i];
            let marker = markers.find(m => m[2] === jid);            
            if (!marker) {
                const job = all_jobs.find(_j => _j.id === jid);
                const label = job.client.first_name;
                const latlng = new google.maps.LatLng(job.lat, job.lng);
                const infowindow = new google.maps.InfoWindow({
                    content: `<div class="info-window">
                        <div>${job.client.first_name} ${job.client.last_name}</div>
                        <div>${job.address}, ${job.city}</div>
                    </div>`,
                    ariaLabel: "Uluru",
                });
                marker = new google.maps.Marker({
                    position: latlng,
                    map: map,
                    animation: google.maps.Animation.DROP,
                    label: label
                });
                marker.addListener("click", () => {
                    infowindow.open({
                        anchor: marker,
                        map,
                    });
                });
                marker.setVisible(true);
                markers.push([marker, job.service_date, job.id]);
                infowindows.push(infowindow);
            }
        }
		if (filtered === true) {
			for (let i = 0; i < markers.length; i ++) {
				if (from_date <= markers[i][1] && markers[i][1] <= to_date) {
					if (marker_visible_ids.includes(markers[i][2])) markers[i][0].setVisible(true);
					else markers[i][0].setVisible(false);
				} else {
					markers[i][0].setVisible(false);
				}
			}
		} else {
			for (let i = 0; i < markers.length; i ++) {
				if (marker_visible_ids.includes(markers[i][2])) {
					markers[i][0].setVisible(true);
				} else {
					markers[i][0].setVisible(false);
				}
			}
		}
	};


    function showDefaultMap() {
        if (company_location.lat) {
            map.setCenter(company_location);
            map.setZoom(7);
        } else {
            map.setZoom(1);
        }
    }

    $: {
		if (map && company_location === null) {
			if (!markers.length) {
                if (map instanceof Element) {
                    center = { lat: 34.483635, lng: -111.669098 };

                    const mapOptions = {
                        zoom: 1,
                        scrollwheel: false,
                        center: center,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                    };

                    map = new google.maps.Map(map, mapOptions);
                    directionsService = new google.maps.DirectionsService();
                    directionsRenderer = new google.maps.DirectionsRenderer({suppressMarkers: true});
                    directionsRenderer.setMap(map);
                }   
				
                const geocoder = new google.maps.Geocoder();
                const address = `${company_details.address}, ${company_details.city}, ${company_details.state}`;
                console.log('address', address);
                geocoder.geocode({ 'address': address }, function(results, status) {
                    if (status === 'OK') {
                        company_location = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
                        console.log('company location', company_location);
                        showDefaultMap();
                    }
                });

			} else {
				// if (from_date && to_date) {
				// 	visible_markers(true);
				// } else {
				// 	visible_markers(false);
				// }
				visible_markers(false);
			}
		}
	}

    window.clear_map = (event) => {
        if (!map || !directionsRenderer) return;
        const elements = document.getElementsByClassName('map-checkbox');
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].checked) elements[i].checked = false;
        }
        marker_visible_ids = [];
        visible_markers(false);
        directionsRenderer.setDirections({ routes: [] });
        showDefaultMap();
        event.preventDefault();
    }

    window.select_map = (event) => {
        const jid = parseInt(event.target.value);
		if (event.target.checked === true) {
            const job = all_jobs.find(_j => _j.id === jid);
            if (job.lat !== undefined && job.lng !== undefined && job.lat !== 200 && job.lng !== 200) {
			    marker_visible_ids.push(jid);
            }
		} else {
			marker_visible_ids = marker_visible_ids.filter(_jid => _jid !== jid);
		}

		// if (from_date && to_date) {
		// 	visible_markers(true);
		// } else {
		// 	visible_markers(false);
		// }
		visible_markers(false);
        directionsRenderer.setDirections({ routes: [] });
        if (marker_visible_ids.length === 0) {
            showDefaultMap();
            return;
        }

        if (marker_visible_ids.length === 1) {
            const job = all_jobs.find(_j => _j.id === marker_visible_ids[0]);
            map.setCenter({ lat: job.lat, lng: job.lng });
            map.setZoom(15);
        } else {
            const bounds = new google.maps.LatLngBounds();
            const locations = [];
            marker_visible_ids.forEach(jid => {
                const job = all_jobs.find(_j => _j.id === jid);
                bounds.extend({ lat: job.lat, lng: job.lng });
                locations.push({ lat: job.lat, lng: job.lng });
            });
            map.fitBounds(bounds);

            // draw route
            const waypoints = locations.slice(1, locations.length - 1).map(location => ({
                location: new google.maps.LatLng(location.lat, location.lng),
                stopover: true
            }));

            directionsService.route(
                {
                    origin: new google.maps.LatLng(locations[0].lat, locations[0].lng),
                    destination: new google.maps.LatLng(locations[locations.length - 1].lat, locations[locations.length - 1].lng),
                    waypoints: waypoints,
                    optimizeWaypoints: true,
                    travelMode: google.maps.TravelMode.DRIVING
                },
                (response, status) => {
                    if (status === "OK") {
                        directionsRenderer.setDirections(response);
                    } else {
                        
                    }
                }
            );
        }
	}

    const numFormatter = new Intl.NumberFormat('en-US');

    const update_price_setting = async () => {
        if (myself['is_subscribed'] !== undefined && !myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }
        if (!(parseFloat(client_margin) >= 0 && parseFloat(contractor_margin) >= 0 && parseFloat(referral_duration) >= 0 && parseFloat(referral_discount) >= 0)) {
            toast_message(false, 'Invalid Price Settings', 2000);
        } else {
            price_setting.client_margin = client_margin;
            price_setting.contractor_margin = contractor_margin;
            price_setting.referral_duration = referral_duration;
            price_setting.referral_discount = referral_discount;
            const res = await doFetch(
                api_host + '/api/landscaper/update/price_setting',
                'POST',
                price_setting,
                { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
            );
            if (res.status) {
                toast_message(true, res.msg, 2000);
                init_data('prices');
            } else {
                toast_message(false, res.msg, 2000);
            }
        }
    }

</script>

<Header title="Dashboard {today}" bind:is_busy={is_busy} />

<div style="padding-left: 15px;padding-right: 15px;">
    <div class="row">
        <div class="analytics jobs">
            <div class="analyticscontent">
                <div class="icon"><i class="fas fa-calendar-check"></i></div>
                <div class="statholder">
                    <div class="stat">{numFormatter.format(all_jobs_number || 0)}</div>
                    <div style="display: flex; justify-content: end;">
                        <div class="subtext">Jobs!</div>
                        <div class="calltoaction pl-2"><a href="/#/Jobs?filter=all"><i class="fas fa-arrow-circle-right"></i></a></div>    
                    </div>
                </div>
            </div>
            <div class="analyticsfooter hidden">
                <div class="calltoaction"><a href="/#/Jobs?filter=all">View Details</a></div>
                <div class="calltoaction"><a href="/#/Jobs?filter=all"><i class="fas fa-arrow-circle-right"></i></a></div>    
            </div>
        </div>
        
        <div class="analytics users">
            <div class="analyticscontent">
                <div class="icon"><i class="fas fa-users"></i></div>
                <div class="statholder">
                    <div class="stat">{all_users_number || 0}</div>
                    <div style="display: flex; justify-content: end;">
                        <div class="subtext">Users!</div>
                        <div class="calltoaction pl-2"><a href="/#/Users?filter=all"><i class="fas fa-arrow-circle-right"></i></a></div>    
                    </div>
                </div>
            </div>
            <div class="analyticsfooter hidden">
                <div class="calltoaction"><a href="/#/Users?filter=all">View Details</a></div>
                <div class="calltoaction"><a href="/#/Users?filter=all"><i class="fas fa-arrow-circle-right"></i></a></div>    
            </div>
        </div>


        <div class="analytics total">
            <div class="analyticscontent">
                <div class="icon"><i class="fas fa-file-invoice-dollar"></i></div>
                <div class="statholder">
                    <div class="stat">{currency_formatter.format(total_earned)}</div>
                    <div style="display: flex; justify-content: end;">
                        <div class="subtext">Sales!</div>
                        <div class="calltoaction pl-2"><a href="/#/Invoices?filter=all"><i class="fas fa-arrow-circle-right"></i></a></div>    
                    </div>
                </div>
            </div>
            <div class="analyticsfooter hidden">
                <div class="calltoaction"><a href="/#/Invoices?filter=all">View Details</a></div>
                <div class="calltoaction"><a href="/#/Invoices?filter=all"><i class="fas fa-arrow-circle-right"></i></a></div>    
            </div>
        </div>
    </div>
    
    <div class="row">
        <div class="daterangesearch">
            Date Range: <Flatpickr options={date_range_options} bind:date_value bind:formattedValue bind:flatpickr />
        </div>   
    </div>

    <div class="row">
        <div class="panel jobs">
            <div class="panelheader">
                <i class="fas fa-calendar-alt"></i>
                <a href="/#/Jobs?filter=today">Today's Jobs</a>
                <!-- <i class="fa fa-refresh" on:click={() => {
                    is_busy = true;
                    init_data('jobs');
                    is_busy = false;
                }}></i> -->
            </div>
            <div style="width: 100%;overflow-x: scroll;">
                <Responsivetable
                    field_formats={field_formats}
                    field_styles={field_styles}
                    sort_functions={{
                        ...sort_functions,
                        "map": false,
                        "dt": false
                    }}
                    statistic_data={statistic_data}
                    num_per_page={500}
                    show_selections={false}
                    show_date_range={false}
                    show_search_box={false}
                    show_pagination={false}
                    bind:is_busy={is_busy}
                    bind:table_header_config={table_header_config}
                    bind:table_data={jobs}
                    bind:total_items={jobs.length}
                    bind:show_items={show_items}
                />
            </div>
        </div>

        <div class="d-flex flex-column">
            <div
                id="map-canvas"
                class="relative w-full rounded h-600-px"
                data-lat="40.748817"
                data-lng="-73.985428"
                style="width: 100%;height: 500px; margin-top: 10px;"
            ></div>
            <div class="panel settings">
                <div class="panelheader"><i class="fas fa-cog"></i><a href="/#/Settingsprice">Pricing Settings Quick List</a></div>
                <table class="paneltable">
                    <tr><th>Setting</th><th>Value</th></tr>
                    <tr>
                        <td>Client Margin</td>
                        <td><input class="settinginput" type="text" bind:value={client_margin} on:blur={(e) => {parseFloat(e.target.value) >= 0 ? e.target.style='border: 1px solid #ccc;' : e.target.style='border: 1px solid red;'}} disabled={myself.role === 'manager'} /></td>
                    </tr>
                    <tr>
                        <td>Contractor Margin</td>
                        <td><input class="settinginput" type="text" bind:value={contractor_margin} on:blur={(e) => {parseFloat(e.target.value) >= 0 ? e.target.style='border: 1px solid #ccc;' : e.target.style='border: 1px solid red;'}} disabled={myself.role === 'manager'} /></td>
                    </tr>
                    <!-- <tr>
                        <td>Referral Duration (days)</td>
                        <td><input class="settinginput" type="text" bind:value={referral_duration} on:blur={(e) => {parseFloat(e.target.value) >= 0 ? e.target.style='border: 1px solid #ccc;' : e.target.style='border: 1px solid red;'}} disabled={myself.role === 'manager'} /></td>
                    </tr>
                    <tr>
                        <td>Referral Discount (%)</td>
                        <td><input class="settinginput" type="text" bind:value={referral_discount} on:blur={(e) => {parseFloat(e.target.value) >= 0 ? e.target.style='border: 1px solid #ccc;' : e.target.style='border: 1px solid red;'}} disabled={myself.role === 'manager'} /></td>
                    </tr> -->
                </table>
                <div class="updatebutton">
                    <button class="save" on:click={update_price_setting}><i class="fas fa-save"></i> Update</button>
                </div>
            </div>
            
        </div>
    </div>
</div>

<style>
    .row {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        grid-gap: 25px;
        row-gap: 5px;
    }
    .updatebutton {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .updatebutton .save {
        width: 200px;
        background-color: #008000;
        color: white;
    }

    .analytics {
        background-color: #666;
        color: whitesmoke;
        border: solid 1px #666;
        border-radius: 5px;
        max-height: 139.9px;
        margin-top: 10px;
        margin-bottom: 10px;
        min-width: 300px;
    }
    .analytics .analyticscontent {
        padding: 10px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .analyticscontent i {
        font-size: 50px;
    }
    .statholder {
        text-align: right;
    }
    .statholder .stat {
        font-size: 36px;
    }
    .statholder .subtext {
        font-weight: bold;
        font-size: 15px;
    }
    .analytics .analyticsfooter {
        background-color: rgb(242, 242, 242);
        color: darkgray;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .calltoaction i {
        cursor: pointer;
        font-size: 20px;
        color: white;
    }
    .analytics.users {
        background-color: rgb(37, 99, 171);
    }
    .analytics.jobs {
        background-color: rgb(74, 175, 70);
    }
    .analytics.total {
        background-color: rgb(237, 159, 53);
    }

    .panel {
        border: solid 1px #999;
        border-radius: 5px;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .panel .panelheader {
        position: relative;
        background-color: rgb(242, 242, 242);
        padding: 10px;
        color: #666;
    }
    .panel .panelheader i {
        margin-right: 15px;
    }
    .paneltable {
        text-align: left;
        color: #666; 
        width: 100%;
    }
    .paneltable, .paneltable th, .paneltable td {
        border: solid 1px #999;
        border-collapse: collapse;        
    }
    .paneltable, .paneltable th, .paneltable td {
        border-right: none;
        border-left: none;
    }
    .paneltable td,th {
        padding: 10px
    }
    .paneltable tr > td:last-of-type {
        text-align: right;
    }
    .paneltable tr:nth-child(even) {
        background-color: #f2f2f2;
    }

    .settinginput {
        width: 150px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .analytics {
            max-width: 100%;
            width: 100%;
            margin-left: auto;
            margin-right: auto;
        }
        .panel {
            width: 100%;
            margin-left: auto;
            margin-right: auto;
        }
        .updatebutton .save {
            width: 100%;
        }

    }
</style>